import { wagerAtoms } from './wagerAtoms';
var changeCombinationDDLState = function (isOpen) {
    wagerAtoms.isCombinationDDLOpen.setValue(isOpen);
};
export { changeCombinationDDLState };
